export const generateTraceParentId = () => {
    const traceId = Array.from({ length: 32 }, () => Math.floor(Math.random() * 16).toString(16)).join('');
    const spanId = Array.from({ length: 16 }, () => Math.floor(Math.random() * 16).toString(16)).join('');
    const traceFlags = '01';

    return `00-${traceId}-${spanId}-${traceFlags}`;
};
